import OTPSelectionPage from "./OTPSelectionPage";
import { connect } from "react-redux";
// import {} from "../../../../store/actions/participant.actions";
// import {} from "../../../../store/selector/participant.selector";

import {
  sendOTPForConfirmationRequest,
  reSendOTPRequest,
  sendOTPRequest
} from "store/actions/auth.actions";
import {
  confirmOtpErrorSelector,
  confirmOtpSuccessSelector,
  sendOTPLoadingSelector,
  sendOTPSuccessSelector
} from "store/selector/auth.selector";

const mapDispatchToProps = {
  sendOTPForConfirmationRequest,
  sendOTPRequest,
  reSendOTPRequest
};

const mapStateToProps = (state) => {
  const confirmOtpError = confirmOtpErrorSelector(state);
  const confirmOtpSuccess = confirmOtpSuccessSelector(state);
  const sendOTPSuccess = sendOTPSuccessSelector(state);
  const sendOTPLoading = sendOTPLoadingSelector(state);

  return { confirmOtpError, confirmOtpSuccess, sendOTPSuccess, sendOTPLoading };
};
export default connect(mapStateToProps, mapDispatchToProps)(OTPSelectionPage);
